<template>
    <v-app>
        <v-content>
            <v-form ref="form">
                <v-container class="data">
                    <v-flex mb-3>
                        <a href="/list" target="_self">Страховые продукты</a>
                    </v-flex>
                    <p v-if="!!exception" class="text-danger">{{ exception }}</p>
                    <h2 class="data__title">Данные полиса ОСАГО</h2>
                    <v-layout class="data__wrapper" row wrap align-end>
                        <v-flex>
                            <v-text-field
                                v-model="policy.insuranceName"
                                label="Страховая компания"
                                :rules="[rules.required]"
                                :disabled="isReadonly"
                            />
                        </v-flex>
                        <v-flex>
                            <v-text-field
                                v-model="policy.number"
                                label="Номер полиса"
                                :rules="[rules.required]"
                                mask="SSS ##########"
                                return-masked-value
                                :disabled="isReadonly"
                            />
                        </v-flex>
                        <v-flex>
                            <v-text-field
                                v-model="policy.premium"
                                label="Страховая премия"
                                :rules="[rules.required]"
                                :disabled="isReadonly"
                            />
                        </v-flex>
                    </v-layout>

                    <h2>Страхователь</h2>
                    <v-layout align-end class="data__wrapper" row wrap>
                        <v-flex lg4>
                            <osago-name
                                v-model="insurer.surname"
                                label="Фамилия"
                                :isDisabled="isReadonly"
                            />
                        </v-flex>
                        <v-flex lg3>
                            <osago-name
                                v-model="insurer.name"
                                label="Имя"
                                :isDisabled="isReadonly"
                            />
                        </v-flex>
                        <v-flex lg3>
                            <osago-name
                                v-model="insurer.patronymic"
                                label="Отчество"
                                optional="true"
                                genitiveLabel="отчества"
                                :noField.sync="insurer.noPatronymic"
                                @change="setGender(insurer)"
                                :isDisabled="isReadonly"
                            />
                            <osago-gender
                                v-if="insurer.noPatronymic"
                                v-model="insurer.gender"
                                label="Пол"
                                :noField.sync="insurer.gender"
                                :isDisabled="isReadonly"
                            />
                        </v-flex>
                        <v-flex lg2>
                            <osago-date
                                v-model="insurer.birthDate"
                                label="Дата рождения"
                                isBirthday="true"
                                :max="insurerMaxBirthdayDate"
                                :isHideMobile="true"
                                :isDisabled="isReadonly"
                            />
                        </v-flex>
                        <v-flex lg2>
                            <h4>Паспорт</h4>
                            <v-text-field
                                v-model="insurer.passport"
                                label="Серия и номер"
                                :rules="[rules.required, rules.passport]"
                                mask="#### ######"
                                return-masked-value
                                :disabled="isReadonly"
                            />
                        </v-flex>
                        <v-flex lg2>
                            <osago-date
                                v-model="insurer.passportDate"
                                label="Дата выдачи"
                                :max="passportMaxDate"
                                :isHideMobile="true"
                                :isDisabled="isReadonly"
                            />
                        </v-flex>
                        <v-flex lg8>
                            <h4>Адрес регистрации</h4>
                            <img class="tip-icon" src="/svg/q.svg"
                                 data-tippy-animateFill="false"
                                 data-tippy-animation="scale"
                                 data-tippy-content="Как в паспорте владельца,<br>на странице места жительства"
                            />
                            <osago-address-dadata
                                :model="insurer.address"
                                class="pt-1"
                                :isDisabled="isReadonly"
                            />
                        </v-flex>
                    </v-layout>

                    <h2 class="data__title">Реквизиты страхователя</h2>
                    <v-layout class="data__wrapper" row wrap>
                        <v-flex lg8>
                            <p><span>ВНИМАНИЕ: </span>Указывайте настоящие данные, без опечаток. ФИО должны совпадать
                                с владельцем карты/счета. Указывайте именно ваши данные, НЕ брата, сестры,
                                тещи и т.п. В противном случае, мы не сможем сделать вам выплату.</p>
                            <!--                            <button @click.prevent.stop="getPolicyTerminationBank">Получить данные банка</button>-->
                        </v-flex>

                        <v-flex lg6>
                            <v-text-field
                                v-model="requisites.bik"
                                label="БИК банка"
                                :rules="[rules.required, rules.bik]"
                                mask="#########"
                                validate-on-blur
                                @change="getPolicyTerminationBank"
                                :disabled="isReadonly"
                            />
                        </v-flex>
                        <v-flex lg6>
                            <v-text-field
                                v-model="requisites.bankName"
                                label="Название банка"
                                :rules="[rules.required]"
                                validate-on-blur
                                :disabled="isReadonly"
                            />
                        </v-flex>

                        <v-flex lg6>
                            <v-text-field
                                v-model="requisites.accountNumber"
                                label="Номер расчетного счета"
                                :rules="[rules.required, rules.accountNumber]"
                                mask="####################"
                                validate-on-blur
                                :disabled="isReadonly"
                            />
                        </v-flex>
                        <v-flex lg6>
                            <v-text-field
                                v-model="requisites.correspondentAccountNumber"
                                label="Номер корреспондентского счета"
                                :rules="[rules.required, rules.correspondentAccountNumber]"
                                mask="####################"
                                validate-on-blur
                                :disabled="isReadonly"
                            />
                        </v-flex>
                    </v-layout>

                    <h2 class="data__title">Причина расторжения</h2>
                    <v-layout class="data__wrapper" row wrap>
                        <v-flex md6>
                            <v-select
                                v-if="!isReadonly"
                                v-model="reason.id"
                                :items="reasons"
                                label="Причина расторжения"
                                :rules="[rules.required]"
                                single-line
                                class="text-black"
                                item-value='UID'
                                item-text='Name'
                                @change="setReasonName"
                            ></v-select>
                            <v-text-field
                                v-else
                                v-model="reason.name"
                                :disabled="isReadonly"
                            >
                            </v-text-field>
                        </v-flex>
                    </v-layout>

                    <h2 class="data__title">Документы</h2>
                    <v-layout v-if="!isReadonly" class="data__wrapper" row wrap>
                        <v-flex xs12 md6 mb-3 v-for="(item, index) in DocumentsReasonCancellation"
                                :key="item.Category.ID">
                            <h4>{{ item.Document }}</h4>
                            <files-upload
                                :index="index"
                                :validation="fileValidation"
                                @getFile="getFile"
                                @removeFiles="removeFiles"
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout v-else class="data__termination" row wrap>
                        <v-flex v-for="item in documentsTitles" :key="item.value">
                            <h4>{{ item + ":" }}</h4>
                            <a v-for="file in termination.termination_files.filter(f => f.doc_name === item)"
                               :key="file.id" :href="file.file" target="_blank" class="data__termination__links">
                                {{ file.name + ',' }}
                            </a>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex lg6>
                            <v-btn
                                @click="validate"
                                class="submit-button block"
                                :loading="isLoading"
                                :disabled="!!exception"
                            >
                                {{ !!termination.company ? 'Заявка отправлена' : 'Отправить в страховую компанию' }}
                            </v-btn>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap class="company-wrapper" v-if="!!termination.company && termination.comment">
                        <v-flex lg3>
                            <img
                                :src="`/` + termination.company.image"
                                alt=""
                                class="data-logo"
                            >
                        </v-flex>
                        <v-flex lg6>
                            <v-layout column wrap>
                                <h2>Комментарий:</h2>
                                <p>{{ termination.comment }}</p>
                            </v-layout>
                        </v-flex>
                        <v-flex>
                            <v-btn
                                class="submit-button block isReadonly-button"
                            >
                                {{ termination.insurance_status ? termination.insurance_status : 'Статус' }}
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
import moment from "moment";

export default {
    props: ['termination', 'edit', 'order', 'exception'],
    data: () => ({
        policy: {
            insuranceName: null,
            insuranceCompanyId: null,
            number: null,
            premium: null,
        },
        insurer: {
            name: null,
            surname: null,
            patronymic: null,
            birthDate: null,
            passport: null,
            passportDate: null,
            address: {},
            noPatronymic: false,
            gender: null,
        },
        requisites: {
            bankName: null,
            bik: null,
            accountNumber: null,
            correspondentAccountNumber: null,
        },
        docs: {
            passport: [],
            saleContract: [],
            requisite: [],
            insurancePolicy: [],
        },
        orderUuid: null,
        reason: {},
        reasons: [],
        documentsTitles: [],
        DocumentsReasonCancellation: [],
        rules: {
            required: v => !!v || 'Обязательное поле',
            passport: v => /^\d{4} \d{6}$/.test(v) || 'Неверный формат',
            bik: v => /^\d{9}$/.test(v) || 'Должен содержать 9 цифр',
            accountNumber: v => /^\d{20}$/.test(v) || 'Должен содержать 20 цифр',
            correspondentAccountNumber: v => /^\d{20}$/.test(v) || 'Должен содержать 20 цифр',
        },
        passportMaxDate: null,
        insurerMaxBirthdayDate: null,
        files: [],
        fileValidation: true,
        isLoading: false,
        isReadonly: false,
        parsedTermination: {},
        sortedTypes: [],
    }),
    async created() {
        console.log(this.edit)
        this.passportMaxDate = moment().format('YYYY-MM-DD');
        this.insurerMaxBirthdayDate = moment().subtract(18, 'years').format('YYYY-MM-DD');
        this.orderUuid = this.order.uuid;
        this.isReadonly = !!this.exception;
        if (this.termination && this.termination.company_id) {
            this.isReadonly = !this.edit;
            this.policy.insuranceName = this.termination.company.name;
            this.policy.insuranceCompanyId = this.termination.company_id;
            this.policy.number = this.termination.policy_number;
            this.policy.premium = this.termination.policy_premium;

            this.insurer.name = this.termination.insurer_name;
            this.insurer.surname = this.termination.insurer_surname;
            this.insurer.patronymic = this.termination.insurer_patronymic;
            this.insurer.birthDate = moment(this.termination.insurer_birth_date).format('YYYY-MM-DD');
            this.insurer.passport = this.termination.insurer_passport_series + ' ' + this.termination.insurer_passport_number;
            this.insurer.passportDate = moment(this.termination.insurer_passport_issue_date).format('YYYY-MM-DD');
            this.insurer.address.search = this.termination.insurer_address;

            this.requisites.bankName = this.termination.requisite_bank_name;
            this.requisites.bik = this.termination.requisite_bank_bik;
            this.requisites.accountNumber = this.termination.requisite_bank_account;
            this.requisites.correspondentAccountNumber = this.termination.requisite_bank_correspondent_account;

            this.reason.name = this.termination.reason_name;
            this.reason.id = this.termination.reason_id;

            if (!this.isReadonly) {
                await this.getReasons();
                await this.setReasonName()
            }

            this.sortedTypes = [...new Set(this.termination.termination_files.map(file => file.type))].sort();

            this.documentsTitles = [...new Set(this.termination.termination_files.map(file => file.doc_name))];
            this.$forceUpdate();
        } else {
            await this.getInfo();
            await this.getReasons();
        }
    },
    methods: {
        setGender(person) {
            if (person.patronymic) {
                person.gender = person.patronymic.endsWith('а') ? 'Женский' : 'Мужской';
            }
        },
        getFile(data, index) {
            this.fileValidation = true
            this.DocumentsReasonCancellation[index].files.push(data);
        },
        removeFiles(index) {
            this.DocumentsReasonCancellation[index].files = [];
        },
        async getInfo() {
            try {
                const response = await axios.get('/osago/new/' + this.orderUuid + '/termination/info');
                const {company, processing, formData} = response.data;

                if (company) {
                    const {id, name} = company;
                    this.policy.insuranceCompanyId = id;
                    this.policy.insuranceName = name;
                }

                if (processing) {
                    const {policy_number, premium} = processing;
                    this.policy.number = policy_number;
                    this.policy.premium = premium;
                }

                if (formData) {
                    const {insurer} = formData;

                    if (insurer) {
                        const {fio, birthday, passport, address} = insurer;

                        if (fio) {
                            const {surname, name, patronymic, noPatronymic} = fio;
                            this.insurer.surname = surname;
                            this.insurer.name = name;
                            this.insurer.patronymic = patronymic;
                            this.insurer.noPatronymic = noPatronymic;
                        }

                        this.insurer.birthDate = birthday;

                        if (passport) {
                            const {seriesNumber, date} = passport;
                            this.insurer.passport = seriesNumber;
                            this.insurer.passportDate = date;
                        }

                        this.insurer.address = address;
                    }
                }

            } catch (error) {
                PNotify.error(error.response.data.error);
                console.error(error);
            }
        },
        async getReasons() {
            try {
                const response = await axios.get('/osago/new/' + this.orderUuid + '/termination/reasons');
                const reasons = response.data

                if (reasons) {
                    for (let i = 0; i < reasons.length; i++) {
                        this.reasons.push(reasons[i]);
                    }
                }
            } catch (error) {
                if (error.response.data.error) {
                    PNotify.error(error.response.data.error);
                } else {
                    PNotify.error('Не удалось получить список причин для разрыва');
                }
            }
        },
        async getPolicyTerminationBank() {
            if (!this.requisites.bik) {
                return;
            }
            try {
                const response = await axios.get('/termination/bank/' + this.requisites.bik);
                const {correspondent_account} = response.data.data;

                this.requisites.bankName = response.data.value;
                this.requisites.correspondentAccountNumber = correspondent_account;

            } catch (error) {
                console.error(error);
            }
        },
        goToFirstError() {
            this.$vuetify.goTo('.error--text', {
                duration: 600,
                offset: 150,
                easing: 'easeInCubic',
            });
        },
        validate() {
            if (this.isReadonly) {
                return;
            }

            let categories = [];
            for (let i = 0; i < this.DocumentsReasonCancellation.length; i++) {
                if (!this.DocumentsReasonCancellation[i].files.length) {
                    categories.push(this.DocumentsReasonCancellation[i].Document);
                }
            }

            if (categories.length) {
                PNotify.error('Загрузите файлы в следующие категории: ' + categories.join(', '));
                return;
            }

            if (this.$refs.form.validate()) {
                this.isLoading = true;
                console.log('Валидация прошла успешно');
                this.createTermination();
            } else {
                this.$nextTick(function () {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    this.goToFirstError();
                });
            }
        },
        createTermination() {
            const data = {
                'policy': this.policy,
                'insurer': this.insurer,
                'requisites': this.requisites,
                'docs': this.DocumentsReasonCancellation,
                'reason': this.reason,
            };
            axios.post('/osago/new/' + this.orderUuid + '/termination/store', data)
                .then(response => {
                    PNotify.success('Отправлено успешно');
                    this.isLoading = false;
                    if (response.data && response.data.id) {
                        window.open('/termination/' + response.data.id, '_self');
                    }
                })
                .catch(error => {
                    if (error.response.data.error) {
                        PNotify.error(error.response.data.error);
                        return;
                    }
                    PNotify.error('Не удалось отправить');
                    this.isLoading = false;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        setReasonName() {
            const selectedReason = this.reasons.find(item => item.UID === this.reason.id);
            if (selectedReason) {
                this.reason.name = selectedReason.Name;
                this.DocumentsReasonCancellation = selectedReason.DocumentsReasonCancellation;
                for (let i = 0; i < this.DocumentsReasonCancellation.length; i++) {
                    this.DocumentsReasonCancellation[i].files = [];
                }
            }
        }
    },
}
</script>

<style scoped lang="scss">
/deep/ h1 {
    font-size: 60px;
    font-family: 'SFProBold', 'SFPro', 'sans-serif';
}

/deep/ h2 {
    font-size: 30px;
    font-family: 'SFProBold', 'SFPro', 'sans-serif';
}

/deep/ h4 {
    display: inline;
    font-size: 16px;
    font-weight: 700;
    font-family: 'SFPro', 'SFProBold', 'sans-serif';
}

/deep/ .v-list__tile__title {
    color: #0a0a0a !important;
}

.data {
    padding-top: 100px;

    &__title {
        padding-bottom: 20px;
        margin-bottom: 0;
        color: black !important;
    }

    &__wrapper {
        margin-bottom: 70px !important;

        p {
            span {
                font-weight: 700;
            }
        }

        button {
            color: #00ba57;
            text-decoration: underline;
        }
    }

    &__termination {
        flex-direction: column;

        a {
            display: inline-block;
            color: #00ba57 !important;
            margin-left: 10px;
        }
    }

    a {
        color: #00ba57 !important;
        &:hover {
            color: #00ba57 !important;
            border-bottom: 1px solid #00ba57 !important;
        }
    }
}

.company-wrapper {
    border-top: 2px solid #d0d1d2;
    padding-top: 20px;
    margin-top: 70px !important;
    align-items: center;

    h2 {
        font-family: 'SFPro', 'Arial', 'sans-serif';
        font-size: 20px;
        color: #a0a0a0;
    }

    p {
        font-size: 18px;
        margin-bottom: 0;
        padding: 20px;
        border-radius: 10px;
        border: 1px solid #000000;
    }
}

.submit-button {
    color: #ffffff;
    line-height: 1.45;
    font-weight: 500;
    font-size: 18px;
    text-transform: none;
    box-shadow: none;

    height: 80px;
    background-color: #00ba57 !important;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding: 0 40px;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.data-logo {
    width: 226px;
}

.isReadonly-button {
    height: 60px;
}

</style>



// WEBPACK FOOTER //
// resources/js/components/CancelContract.vue